import { Habit } from '@griply/types';
import { buildLifeAreaHabitSections, getWeekStartsOn } from '@griply/utils';
import { useGoals } from 'features/goals';
import { useLocalizedLifeAreas } from 'features/life-areas';
import { useHabits } from 'features/tasks';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { useEntityLinks } from 'shared/hooks/use-entity-links';
import { useUser } from 'shared/hooks/use-user';

export const useLifeAreaHabitSections = () => {
  const today = useToday();
  const user = useUser();

  const habits = useHabits({
    uncompletedOnly: true,
    unArchivedOnly: true,
  });
  const goals = useGoals();
  const lifeAreas = useLocalizedLifeAreas();
  const links = useEntityLinks();

  const sections = useMemo(
    () =>
      buildLifeAreaHabitSections({
        habits,
        lifeAreas,
        goals,
        links,
        lifeAreaSorting: user?.settings?.lifeAreaSorting,
        habitSortingMode: user?.settings?.habitSortingMode,
        habitGroupSorting: user?.settings?.habitGroupSorting?.lifeArea?.sorting,
        today,
        weekStartsOn: getWeekStartsOn(user),
      }).map((group) => ({
        id: group.lifeAreaId,
        items: group.tasks as Habit[],
      })),
    [habits, lifeAreas, goals, links, user, today],
  );

  return {
    sections,
    habits,
  };
};
